module.exports = __webpack_public_path__ + "static/media/shopify2.06bc2850.png";